/*
 * Copyright (c) 2016. by netzkolchose.de UG (haftungsbeschränkt) - stephan
 */

var $ = require("jquery");
var slick = require("slick-carousel");

$(".slick-stage").slick({
    "adaptiveHeight": true,
    autoplay: false,
    autoplaySpeed: 99500
});
